<template>
  <div v-if="system && system.homepage === null">
    <page-header
      header="Updates / News"
    />

    <div class="flex flex-wrap items-start mt-6 pt-8 -mx-6">
      <div class="w-full lg:w-3/5 px-6 flex">
        <div class="w-full">
          <div class="p-6 w-full flex bg-white rounded-lg">
            <div class="bg-tertiary rounded-lg w-32 h-32 p-4 -mt-12">
              <icon name="news" class="text-white" />
            </div>
            <h2 class="text-3xl px-4 font-medium ml-6 mt-6">
              Updates
            </h2>
          </div>

          <div
            v-for="article in filteredArticles"
            :key="article.id"
            class="mt-4 p-4 bg-white rounded-lg"
          >
              <h3 class="text-xl font-medium uppercase mb-2">
                {{ article.title}}
              </h3>
              <div
                v-if="article.website_url"
                class="my-4 h-64 bg-center bg-contain bg-no-repeat"
                :style="{ backgroundImage: `url(${article.website_url})` }"
              ></div>
              <div
                class="article-content mb-2"
                v-html="article.content"
              ></div>
              <small>{{ moment(article.updated_at).fromNow() }}</small>
          </div>
        </div>
      </div> <!-- news -->

      <div v-if="system && system.twitter" class="w-full mt-10 lg:mt-0 lg:w-2/5 px-6 flex">
        <div class="p-6 bg-white rounded-lg flex-1">
          <div class="flex">
            <div class="rounded-lg w-16 h-16 overflow-hidden">
              <icon name="twitter_white_on_blue" />
            </div>
            <h2 class="font-medium mt-6 ml-6">
              Twitter
            </h2>
          </div>

          <twitter-timeline />
        </div>
      </div> <!-- twitter -->
    </div>
  </div>

  <loader v-else />
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  created () {
    if (this.system.homepage !== null) {
      this.$router.replace(this.system.homepage)
    }
  },
  methods: {
    moment: moment,
    getFilteredArticles () {
      return this.articles.filter(a => {
        if ([7, 8].includes(this.selectedOffice.network_id) && a.assigned_countries.length > 0 && a.assigned_countries.includes('UKA')) {
          return (a.assigned_network === this.selectedOffice.network_id || a.assigned_network == null) && (this.selectedOffice.associate === true || a.assigned_countries.includes(this.selectedOffice.country))
        } else if ([7, 8].includes(this.selectedOffice.network_id) && a.assigned_countries.length > 0) {
          return (a.assigned_network === this.selectedOffice.network_id || a.assigned_network == null) && (a.assigned_countries.includes(this.selectedOffice.country))
        }
        return a.assigned_network === this.selectedOffice.network_id || a.assigned_network == null
      })
    }
  },
  computed: {
    ...mapState(['system', 'articles', 'selectedOffice']),
    filteredArticles: function () {
      return this.getFilteredArticles()
    }
  }

}
</script>

<style lang="scss">
.article-content {
  & p {
    @apply my-4;
  }
  & img {
    @apply m-2 mt-1 p-2 pt-1;
  }
}
</style>
